<template>
  <validation-provider
    :rules="rules"
    :name="name"
    :vid="vid"
    ref="validator"
    v-slot="{ errors }"
  >
    <editor v-model="currentValue" v-bind="$attrs" :error="errors[0]" />
  </validation-provider>
</template>

<script>
import Editor from "./Editor";

export default {
  name: "control-editor",

  components: {
    Editor
  },

  props: {
    value: {
      type: String,
      default: ""
    },

    name: String,
    vid: String,
    rules: [String, Object]
  },

  data() {
    return {
      currentValue: ""
    };
  },

  mounted() {
    this.currentValue = this.value;
  },

  methods: {
    setErrors(errors) {
      this.$refs.validator.setErrors(errors);
    }
  },

  watch: {
    value(val) {
      this.currentValue = val;
    },

    currentValue(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style></style>
